import store from '@/states/index.js'

import SupplierRequest from '../SupplierRequest.vue'

export default [
    {
        path: '/supplierrequest',
        component: SupplierRequest,
        name: 'supplierrequest',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]